import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: 20px 1fr;
`;

const StyledLetter = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background-color: #253289;
	border-radius: 5px 0 0 5px;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #ffffff;
	}
`;

const StyledDate = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: auto;
	height: 20px;
	border: 1px solid #253289;
	border-radius: 0 5px 5px 0;

	${Text} {
		font-weight: 700;
		font-size: 10px;
		color: #253289;
	}
`;

export { StyledContainer, StyledDate, StyledLetter };
